// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import CustomTimePicker from '../layout/CustomTimePicker';
import ContactInfoForWorkOrder from '../layout/workOrderEditElements/contactInfoForWorkOrder';
import UploadDocumentsToWorkOrder from '../layout/workOrderEditElements/UploadDocumentsToWorkOrder';
import SelectWorkOrderWorkTypes from '../layout/workOrderEditElements/selectWorkOrderWorkTypes';
import SelectWorkOrderCompany from '../layout/workOrderEditElements/SelectWorkOrderCompany';
import SelectWorkProject from '../layout/workOrderEditElements/SelectWorkOrderProject';
import EditorInput from '../layout/workOrderEditElements/EditorInput';
import Loader from '../dashboard/common/Loader';
import Notification from '../notification';
import { toggleModal } from '../../storage/actions/modalsActions';
import {
  bulkEditWorkOrders,
  getWorkOrdersForBulk,
} from '../../storage/actions/workOrdersActions';
import { getAccountBalanceByClient } from '../../storage/actions/profile';
import combineDateAndTime from '../../utils/addTimeToDatefromAM_PMFormatString';
import { getLocalISODate } from '../../utils/getDateWithOffset';
import { localCurrencySettings } from '../../utils/constans';
import prepareFilters from '../../utils/prepareFilters';
import { getStatus } from '../../utils/api/get/getWorkOrders';
import { endDateFilter, startDateFilter } from '../../utils/pickerDateFilters';

class BulkEditWorkOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersInfo: [],
      isLoading: true,
      fieldsToUpdate: new Set(),
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      startAMPM: '',
      endAMPM: '',
      startTimeHour: '',
      endTimeHour: '',
      startTimeMinutes: '',
      endTimeMinutes: '',
      amount: 0,
      quantity: 0,
      basicType: 'Hour',
      percentCommunication: '',
      percentWork: '',
      percentDeliverables: '',
      variableAmount: 0,
      variablePayAfter: 0,
      maxQuantity: 0,
      // eslint-disable-next-line react/no-unused-state
      variableType: 'Hour',
      contactInfo: [],
      file: [],
      selectedWorkOrderWorkTypes: [],
      totalAmount: 0,
      newTotalAmount: 0,
      amountWithinApp: 0,
      fundsRemaining: 0,
      holdFounds: 0,
      potentialPay: 0,
      payOutsideOfApp: false,
      workOrderCount: 0,
      fundsNeeded: 0,
      requestData: {},
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.modalState?.isOpen) {
      this.initBulkEdit();
    }
  }

  componentDidUpdate(prevProps) {
    const wasOpen = prevProps.modalState?.isOpen;
    const isOpen = this.props.modalState?.isOpen;

    if (!wasOpen && isOpen) {
      this.initBulkEdit();
      return;
    }

    if (!isOpen) {
      return;
    }

    const prevBalance = prevProps.profile?.balance;
    const nextBalance = this.props.profile?.balance;
    const balanceChanged = prevBalance?.total_balance !== nextBalance?.total_balance
      || prevBalance?.on_hold !== nextBalance?.on_hold;

    if (!balanceChanged) {
      return;
    }

    const fundsRemaining = this.getRemainFundsInfo();
    if (this.state.fundsRemaining !== fundsRemaining) {
      this.setState({ fundsRemaining });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  initBulkEdit = () => {
    this.setState({
      isLoading: true,
      fieldsToUpdate: new Set(),
      fundsRemaining: this.getRemainFundsInfo(),
    });
    this.fetchWorkOrders();
  };

  fetchWorkOrders = async () => {
    const {
      getAccountBalanceByClient,
      getWorkOrdersForBulk,
      selectedWorkOrders,
      modalState,
      search,
      filters,
      activeTab,
    } = this.props;
    await getAccountBalanceByClient();
    const requestData = modalState?.type?.mode === 'useFilters'
      ? {
        ...search,
        filters: prepareFilters(filters),
      }
      : { workOrdersId: selectedWorkOrders };
    const ordersInfo = await getWorkOrdersForBulk({ ...requestData, ...getStatus(activeTab) });
    const totalAmount = ordersInfo.reduce((acc, cur) => acc + (cur.holdFunds || cur.fundsExpected || 0), 0);
    const workOrderCount = ordersInfo.reduce((acc, cur) => acc + (cur.count || 0), 0);
    const amountWithinApp = ordersInfo.reduce((acc, cur) => acc + (cur.holdFunds || 0), 0);

    if (!this._isMounted || !this.props.modalState?.isOpen) {
      return;
    }

    this.setState({
      ordersInfo,
      totalAmount,
      workOrderCount,
      requestData,
      amountWithinApp,
      isLoading: false,
    });
  }

  getRemainFundsInfo = () => {
    const { profile } = this.props;
    const totalBalance = Number(profile?.balance?.total_balance) || 0;
    const onHold = Number(profile?.balance?.on_hold) || 0;
    return totalBalance - onHold;
  }

  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal(false, 'bulkEditWorkOrders');
  }

  getUploadedDocuments = (file) => {
    this.setState({ file });
  }

  calculatePayDividedValues = () => {
    const {
      percentCommunication: communication, percentWork: work, percentDeliverables: deliverables,
    } = this.state;
    const percentCommunication = +communication || 0;
    const percentWork = +work || 0;
    const percentDeliverables = +deliverables || 0;
    if (percentCommunication && percentWork && percentDeliverables) return;
    if ((100 - (percentCommunication + percentWork + percentDeliverables)) <= 0) return;
    const dif = 100 - (percentCommunication + percentWork + percentDeliverables);
    const emptyCount = !percentCommunication + !percentWork + !percentDeliverables;
    this.setState({
      percentCommunication: (percentCommunication || dif / emptyCount).toFixed(3),
      percentWork: (percentWork || dif / emptyCount).toFixed(3),
      percentDeliverables: (percentDeliverables || dif / emptyCount).toFixed(3),
    });
  }

  handlerContactInfoChanges = newContactList => {
    this.setState({ contactInfo: newContactList });
  }

  updateTotalAmount = (isPayLocationChecked = false) => {
    const {
      amount, quantity, basicType, variableAmount: vAmount, maxQuantity: vQty,
      workOrderCount, ordersInfo, totalAmount, amountWithinApp
    } = this.state;

    const newCount = isPayLocationChecked ? workOrderCount : ordersInfo.filter(item => !item.payOutsideOfApp).length
    const potentialPay = amount * (basicType === 'Site' ? 1 : quantity);
    const holdFounds = vAmount
      ? potentialPay + vAmount * vQty
      : potentialPay;
    this.setState({
      potentialPay,
      holdFounds,
      fundsNeeded: (holdFounds * newCount) - amountWithinApp,
      newTotalAmount: holdFounds * workOrderCount,
    });
  }

  fieldsValue = (form, fieldName) => {
    const {
      startDate, startTime, endDate, endTime,
      percentCommunication: perCommunication, percentWork: perWork,
      percentDeliverables: perDeliverables, basicType, variablePayAfter: vAfter,
      holdFounds, potentialPay, contactInfo,
      amount, variableAmount: vAmount, quantity, payOutsideOfApp,
      newTotalAmount, totalAmount, selectedWorkOrderWorkTypes, variableType,
    } = this.state;
    switch (fieldName) {
      case 'dateTimeFields': {
        return {
          startDate: combineDateAndTime(startDate, startTime),
          startTime,
          endDate: getLocalISODate(endDate, true, true),
          endTime,
        };
      }
      case 'editPay': {
        // eslint-disable-next-line max-len
        if (parseFloat(perCommunication) + parseFloat(perWork) + parseFloat(perDeliverables) !== 100) {
          return { errorMessage: 'Communication, Work and Deliverables should total to 100%.' };
        }
        if (!amount || !quantity) {
          return { errorMessage: 'Please enter correct amount and quantity in base pay section' };
        }
        return {
          amount,
          quantity,
          payBaseRateAsMinimum: form.payBaseRateAsMinimum?.checked,
          variableAmount: vAmount,
          variablePayAfter: vAfter,
          maxQuantity: quantity,
          variableType: variableType || 'Hour',
          percentCommunication: perCommunication,
          percentWork: perWork,
          percentDeliverables: perDeliverables,
          holdFounds,
          potentialPay,
          fundsNeeded: newTotalAmount - totalAmount,
        };
      }
      case 'editPayLocation': {
        return {
          payOutsideOfApp: payOutsideOfApp || false,
        }
      }
      case 'replaceContacts': {
        if (!contactInfo.length) {
          return { errorMessage: 'Please enter Correct Contact ' };
        }
        return {
          contactInfo,
        };
      }
      case 'uploadDocuments': return {
        isNeedDeliverables: form.isNeedDeliverables.checked,
      };
      case 'workType': {
        if (!(selectedWorkOrderWorkTypes && selectedWorkOrderWorkTypes.length)) {
          return { errorMessage: 'Please choose your work type' };
        }
        return {
          toolsId: selectedWorkOrderWorkTypes.map((item) => item.value),
        };
      }
      case 'deleteAllDocuments': return {
        deleteAllDocuments: form[fieldName].checked,
      };
      case 'title': {
        if (!form[fieldName].value.trim()) {
          return { errorMessage: 'Title is required' };
        }
        return {
          title: form[fieldName].value,
        };
      }

      case 'description': {
        if (!form[fieldName].value.trim()) {
          return { errorMessage: 'Description is required' };
        }
        return {
          description: form[fieldName].value,
        };
      }

      default: {
        return { [fieldName]: form[fieldName].value || '' };
      }
    }
  }

  // eslint-disable-next-line consistent-return
  handlerSubmit = (event) => {
    const { fieldsToUpdate, file, requestData } = this.state;
    const {
      bulkEditWorkOrders,
      activeTab,
    } = this.props;
    event.preventDefault();
    const tmpFieldsToUpdate = [...fieldsToUpdate];

    if (!this.state.payOutsideOfApp && (this.state.fundsNeeded > this.state.fundsRemaining)) {
      return Notification('error', { message: 'Not enough funds availble' });
    }

    let data = {};
    tmpFieldsToUpdate.forEach((fieldName) => {
      data = { ...data, ...this.fieldsValue(event.target, fieldName) };
    });
    if (data.errorMessage) {
      Notification('error', { message: data.errorMessage });
    } else {
      const fd = new FormData();
      fd.append('data', JSON.stringify(data));
      if (file) {
        file.forEach((item) => {
          fd.append('file', item);
        });
      }
      fd.append('tab', activeTab);
      fd.append('workOrdersFilter', JSON.stringify({ ...requestData, ...getStatus(activeTab) }));
      bulkEditWorkOrders(fd);
    }
  }

  handlerInput = (name, value, updateTotalAmount) => {
    const { variableType, basicType } = this.state;
    const newData = {
      [name]: value || '',
    };
    if (
      name === 'quantity'
      && ((variableType === basicType) || ((variableType === 'Hour') && (basicType === 'Site')))
    ) {
      newData.variablePayAfter = value || '';
    }
    this.setState(newData, () => {
      if (updateTotalAmount) this.updateTotalAmount();
    });
  }

  handlerUpdatingFields = (name, checked) => {
    const { fieldsToUpdate } = this.state;
    const newFieldsToUpdateSet = new Set([...fieldsToUpdate]);
    if (checked) {
      newFieldsToUpdateSet.add(name);
    } else {
      newFieldsToUpdateSet.delete(name);
    }
    this.setState({
      fieldsToUpdate: newFieldsToUpdateSet,
    });
    if (name === 'editPayLocation') {
      this.updateTotalAmount(checked);
    }
  }

  render() {
    const {
      modalState,
      profile,
    } = this.props;
    const {
      fieldsToUpdate,
      startDate,
      endDate,
      startTime,
      endTime,
      startAMPM,
      endAMPM,
      startTimeHour,
      endTimeHour,
      startTimeMinutes,
      endTimeMinutes,
      amount,
      quantity,
      basicType,
      variableType,
      variableAmount: vAmount,
      variablePayAfter: vAfter,
      maxQuantity: vQty,
      percentCommunication,
      percentWork,
      percentDeliverables,
      contactInfo,
      file,
      selectedWorkOrderWorkTypes,
      totalAmount,
      newTotalAmount,
      isLoading,
      fundsRemaining,
      payOutsideOfApp,
      fundsNeeded,
      workOrderCount
    } = this.state;

    if (!modalState?.isOpen) {
      return null;
    }

    return (
      <div
        className="dashboard-modal dashboard-modal--open dashboard-modal--filters dashboard-modal--bulk-edit"
        role="presentation"
      >
        <div
          className="dashboard-modal-panel"
          role="dialog"
          aria-modal="true"
          aria-labelledby="bulk-edit-title"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="dashboard-modal-header">
            <div className="dashboard-modal-title" id="bulk-edit-title">
              Bulk Edit
            </div>
            <button
              type="button"
              className="dashboard-modal-close"
              aria-label="Close bulk edit"
              onClick={this.closeModal}
            />
          </div>

          <div className="dashboard-modal-body wurqly-modal-scroll dashboard-modal-form-scroll">
            <p className="bulk-edit-warning">
              WARNING! The checked boxes will override ALL DATA in selected work orders
            </p>
            {
              isLoading
                ? (
                  <div className="flex-box flex-center bulk-edit-loader">
                    <Loader />
                  </div>
                )
                : (
                  <form className="bulk-edit-form" onSubmit={this.handlerSubmit}>
                  <div className="bulk-edit-fields">
                      <label htmlFor="dateTimeFieldsCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                        <input
                          id="dateTimeFieldsCheckbox"
                          type="checkbox"
                          name="dateTimeFieldsCheckbox"
                          className="input-field"
                          placeholder="Edit Date And Time Fields"
                          onChange={(event) => this.handlerUpdatingFields('dateTimeFields', event.target.checked)}
                          checked={fieldsToUpdate.has('dateTimeFields')}
                        />
                        <span>Edit Date And Time Fields</span>
                      </label>
                    {
                      fieldsToUpdate.has('dateTimeFields')
                        ? (
                          <>
                            <div className="field_row">
                              <div className="field_name">
                                <label htmlFor="startDate">Start Date</label>
                              </div>
                              <div className="field_block">
                                <DatePicker
                                  className="form-control"
                                  dateFormat="MM/dd/yyyy"
                                  /* eslint-disable-next-line camelcase */
                                  selected={startDate}
                                  onChange={(date) => this.handlerInput('startDate', date)}
                                  placeholder="Start Date"
                                  style={{
                                    marginRight: '10px',
                                  }}
                                  filterDate={startDateFilter}
                                />
                              </div>
                            </div>
                            <div className="field_row">
                              <div className="field_name">
                                <label htmlFor="endDate">End Date</label>
                              </div>
                              <div className="field_block">
                                <DatePicker
                                  className="form-control"
                                  dateFormat="MM/dd/yyyy"
                                  /* eslint-disable-next-line camelcase */
                                  selected={endDate}
                                  onChange={(date) => this.handlerInput('endDate', date)}
                                  placeholder="Start Date"
                                  style={{
                                    marginRight: '10px',
                                  }}
                                  filterDate={endDateFilter}
                                />
                              </div>
                            </div>
                            <div className="field_row">
                              <div className="field_name">
                                <label htmlFor="startTime">Start Time</label>
                              </div>
                              <div className="field_block">
                                <CustomTimePicker
                                  getValue={(value) => this.handlerInput('startTime', value)}
                                  dayTime={startAMPM}
                                  hours={startTimeHour}
                                  minutes={startTimeMinutes}
                                  value={startTime}
                                  placeholder="Start Time"
                                />
                              </div>
                            </div>
                            <div className="field_row">
                              <div className="field_name">
                                <label htmlFor="endTime">End Time</label>
                              </div>
                              <div className="field_block">
                                <CustomTimePicker
                                  getValue={(value) => this.handlerInput('endTime', value)}
                                  dayTime={endAMPM}
                                  hours={endTimeHour}
                                  minutes={endTimeMinutes}
                                  value={endTime}
                                  placeholder="End Time"
                                />
                              </div>
                            </div>

                          </>
                        )
                        : <></>
                    }
                    <div className="p-10-0">
                      <div className="field_block checkbox_group">
                        <label htmlFor="editPayCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="editPayCheckbox"
                            type="checkbox"
                            name="editPayCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('editPay', event.target.checked)}
                            checked={fieldsToUpdate.has('editPay')}
                          />
                          <span>Edit Pay</span>
                        </label>
                      </div>
                      {
                        fieldsToUpdate.has('editPay')
                          ? (
                            <>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="basePay">Base Pay</label>
                                </div>
                                <div className="field_block">
                                </div>
                              </div>

                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="basePay">Amount</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    className="small-input border-none-with-padding"
                                    name="amount"
                                    value={amount}
                                    onChange={({ target }) => {
                                      const value = +target.value || 0;
                                      this.handlerInput(target.name, value, true);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="quantity">{`Qty${basicType === 'Site' ? ' (Est Hours)' : ''}`}</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    className="small-input border-none-with-padding"
                                    name="quantity"
                                    value={quantity}
                                    onChange={({ target }) => {
                                      const value = +target.value || 0;
                                      this.handlerInput(target.name, value, true);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="estPay">Est.Pay</label>
                                </div>
                                <div className="field_block">
                                  {(amount * (basicType === 'Site' ? 1 : quantity)).toLocaleString('en-US', localCurrencySettings)}

                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="per">Per</label>
                                </div>
                                <div className="field_block">
                                  <select
                                    className="border-none-with-padding"
                                    name="basicType"
                                    onChange={({ target }) => {
                                      this.handlerInput(target.name, target.value, true);
                                    }}
                                  >
                                    <option value="Hour">Hour</option>
                                    <option value="Device">Device</option>
                                    <option value="Site">Site</option>
                                  </select>

                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="payBaseRateAsMinimum">Pay base as min.</label>
                                </div>
                                <div className="field_block checkbox_group">
                                  <label htmlFor="payBaseRateAsMinimum" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                                    <input
                                      id="payBaseRateAsMinimum"
                                      type="checkbox"
                                      name="payBaseRateAsMinimum"
                                      className="input-field"
                                    />
                                    <span>Pay base as min.</span>
                                  </label>
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="howPayIsDivided">How Pay is Divided</label>
                                </div>
                                <div className="field_block">
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="communication">Communication</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    className="small-input border-none-with-padding"
                                    name="percentCommunication"
                                    value={percentCommunication}
                                    onChange={({ target }) => {
                                      this.handlerInput(target.name, target.value);
                                    }}
                                    onBlur={this.calculatePayDividedValues}
                                  />
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="work">Work</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    className="small-input border-none-with-padding"
                                    name="percentWork"
                                    value={percentWork}
                                    onChange={({ target }) => {
                                      this.handlerInput(target.name, target.value);
                                    }}
                                    onBlur={this.calculatePayDividedValues}
                                  />
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="deliverables">Deliverables</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    className="small-input border-none-with-padding"
                                    name="percentDeliverables"
                                    value={percentDeliverables}
                                    onChange={({ target }) => {
                                      this.handlerInput(target.name, target.value);
                                    }}
                                    onBlur={this.calculatePayDividedValues}
                                  />
                                </div>
                              </div>

                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="variablePay">Variable Pay (Optional)</label>
                                </div>
                                <div className="field_block">
                                </div>
                              </div>

                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="variablePay">Amount</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    className="small-input border-none-with-padding"
                                    name="variableAmount"
                                    value={vAmount}
                                    onChange={({ target }) => {
                                      const value = +target.value || 0;
                                      this.handlerInput(target.name, value, true);
                                    }}
                                  />
                                </div>
                              </div>



                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="variablePay">After</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    disabled={(variableType === basicType) || ((variableType === 'Hour') && (basicType === 'Site'))}
                                    className="small-input border-none-with-padding"
                                    name="variablePayAfter"
                                    value={vAfter}
                                    onChange={({ target }) => {
                                      const value = +target.value || 0;
                                      this.handlerInput(target.name, value, true);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="maxQuantity">Max. Qty</label>
                                </div>
                                <div className="field_block">
                                  <input
                                    type="number"
                                    className="small-input border-none-with-padding"
                                    name="maxQuantity"
                                    value={vQty}
                                    onChange={({ target }) => {
                                      const value = +target.value || 0;
                                      this.handlerInput(target.name, value, true);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="variablePay">Per</label>
                                </div>
                                <div className="field_block">
                                  <select
                                    className="border-none-with-padding"
                                    name="variableType"
                                    onChange={({ target }) => {
                                      this.handlerInput(target.name, target.value);
                                    }}
                                  >
                                    <option value="Hour">Hour</option>
                                    <option value="Device">Device</option>
                                    <option value="Site">Site</option>
                                  </select>
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="variablePay">Total Amount (Selected work order)</label>
                                </div>
                                <div className="field_block">
                                  <h4>
                                    {totalAmount.toLocaleString('en-US', localCurrencySettings)}
                                  </h4>
                                </div>
                              </div>
                              <div className="field_row">
                                <div className="field_name">
                                  <label htmlFor="variablePay">New Total Amount: (Selected work order)</label>
                                </div>
                                <div className="field_block">
                                  <h4>
                                    {newTotalAmount.toLocaleString('en-US', localCurrencySettings)}
                                  </h4>
                                </div>
                              </div>
                              {profile.balance.total_balance && fundsRemaining
                                ? (
                                  <>
                                    <div className="field_row">
                                      <div className="field_name">
                                        <label htmlFor="variablePay">Funds Remaining:</label>
                                      </div>
                                      <div className="field_block">
                                        <h4>
                                          {(fundsRemaining).toLocaleString('en-US', localCurrencySettings)}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="field_row">
                                      <div className="field_name">
                                        <label htmlFor="variablePay">Funds Needed:</label>
                                      </div>
                                      <div className="field_block">
                                        <h4>
                                          {payOutsideOfApp
                                            ? '$0.00'
                                            : (fundsNeeded).toLocaleString('en-US', localCurrencySettings)}
                                        </h4>
                                      </div>
                                    </div>
                                  </>
                                )
                                : <></>}


                            </>
                          )
                          : <></>
                      }
                    </div>
                  {/* <div md="12" className="p-10-0">
                    <div className="field_block checkbox_group">
                      <label htmlFor="editPayLocationCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                        <input
                          id="editPayLocationCheckbox"
                          type="checkbox"
                          name="editPayLocationCheckbox"
                          className="input-field"
                          onChange={(event) => this.handlerUpdatingFields('editPayLocation', event.target.checked)}
                          checked={fieldsToUpdate.has('editPayLocation')}
                        />
                        Edit pay location
                      </label>
                    </div>
                  </div>
                  {fieldsToUpdate.has('editPayLocation') ?
                    <>
                      <div className="field_block checkbox_group">
                        <label htmlFor="payWithinApp" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="payWithinApp"
                            type="radio"
                            name="payOutsideOfApp"
                            className="input-field"
                            checked={!payOutsideOfApp}
                            onChange={({ target }) => {
                              this.handlerInput(target.name, !target.checked);
                            }}
                          />
                          Pay within app
                        </label>
                      </div>
                      <div className="field_block checkbox_group">
                        <label htmlFor="payOutsideOfApp" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="payOutsideOfApp"
                            type="radio"
                            name="payOutsideOfApp"
                            className="input-field"
                            checked={payOutsideOfApp}
                            onChange={({ target }) => {
                              this.handlerInput(target.name, target.checked);
                            }}
                          />
                          Pay outside app
                        </label>
                      </div>
                      <div className="field_row">
                        <div className="field_name">
                          <label htmlFor="totalAmount">Total Amount:(Selected work order)</label>
                        </div>
                        <div className="field_block">
                          <h4>
                            {totalAmount.toLocaleString('en-US', localCurrencySettings)}
                          </h4>
                        </div>
                      </div>
                      <div className="field_row">
                        <div className="field_name">
                          <label htmlFor="variablePay">Funds Needed:</label>
                        </div>
                        <div className="field_block">
                          <h4>
                            {fundsNeeded.toLocaleString('en-US', localCurrencySettings)}

                          </h4>
                        </div>
                      </div>
                      {profile.balance.total_balance && fundsRemaining
                        ? (
                          <>
                            <div className="field_row">
                              <div className="field_name">
                                <label htmlFor="variablePay">Funds Remaining:</label>
                              </div>
                              <div className="field_block">
                                <h4>
                                  {(fundsRemaining).toLocaleString('en-US', localCurrencySettings)}
                                </h4>
                              </div>
                            </div>
                            <div className="field_row">
                              <div className="field_name">
                                <label htmlFor="variablePay">Funds Needed:</label>
                              </div>
                              <div className="field_block">
                                <h4>
                                  {payOutsideOfApp
                                    ? '$0.00'
                                    : (fundsNeeded).toLocaleString('en-US', localCurrencySettings)}
                                </h4>
                              </div>
                            </div>
                          </>
                        )
                        : <></>}

                    </>
                    : <></>
                  } */}
                  <div md="12" className="p-10-0">
                    <div className="field_block checkbox_group">
                      <label htmlFor="replaceContactsCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                        <input
                          id="replaceContactsCheckbox"
                          type="checkbox"
                          name="replaceContactsCheckbox"
                          className="input-field"
                          onChange={(event) => this.handlerUpdatingFields('replaceContacts', event.target.checked)}
                          checked={fieldsToUpdate.has('replaceContacts')}
                        />
                        <span>Replace Contacts</span>
                      </label>
                    </div>
                    {fieldsToUpdate.has('replaceContacts')
                      ? (
                        <ContactInfoForWorkOrder
                          handlerChanges={this.handlerContactInfoChanges}
                          contactList={contactInfo}
                        />
                      )
                      : <></>}
                  </div>
                  <div md="12" className="p-10-0">
                    <div className="field_block checkbox_group">
                      <label htmlFor="deleteAllDocumentsCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                        <input
                          id="deleteAllDocumentsCheckbox"
                          type="checkbox"
                          name="deleteAllDocuments"
                          className="input-field"
                          onChange={(event) => this.handlerUpdatingFields('deleteAllDocuments', event.target.checked)}
                          checked={fieldsToUpdate.has('deleteAllDocuments')}
                        />
                        <span>Delete All Documents</span>
                      </label>
                    </div>
                  </div>
                  <div className="bulk-edit-section">
                    <div md="12" className="p-10-0">
                      <div className="field_block checkbox_group">
                        <label htmlFor="uploadDocumentsCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="uploadDocumentsCheckbox"
                            type="checkbox"
                            name="uploadDocumentsCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('uploadDocuments', event.target.checked)}
                            checked={fieldsToUpdate.has('uploadDocuments')}
                          />
                          <span>Upload Documents</span>
                        </label>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('uploadDocuments')
                        ? (
                          <UploadDocumentsToWorkOrder
                            getUploadedDocuments={this.getUploadedDocuments}
                            documents={file}
                            toggleModal={toggleModal}
                          />
                        )
                        : <></>
                    }
                  </div>
                  <div className="p-10-0">
                    <div md="2" className="flex-box align-items-center">
                      <div className="field_block checkbox_group">
                        <label htmlFor="workOrderTitleCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="workOrderTitleCheckbox"
                            type="checkbox"
                            name="workOrderTitleCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('title', event.target.checked)}
                            checked={fieldsToUpdate.has('title')}
                          />
                          <span>WO Title:</span>
                        </label>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('title')
                        ? (
                          <div className="field_row">
                            <div className="field_name">
                              <label htmlFor="variablePay">WO Title:</label>
                            </div>
                            <div className="field_block">
                              <input
                                type="text"
                                className="border-none-with-padding full-width"
                                name="title"
                              />
                            </div>
                          </div>

                        )
                        : <></>
                    }
                  </div>
                  <div className="p-10-0">
                    <div md="2">
                      <div className="flex-box flex-align-center" style={{ height: '38px' }}>
                        <div className="field_block checkbox_group">
                          <label htmlFor="workTypeCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                            <input
                              id="workTypeCheckbox"
                              type="checkbox"
                              name="workTypeCheckbox"
                              className="input-field"
                              onChange={(event) => this.handlerUpdatingFields('workType', event.target.checked)}
                              checked={fieldsToUpdate.has('workType')}
                            />
                            Work Type:
                          </label>
                        </div>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('workType')
                        ? (
                          <div>
                            <SelectWorkOrderWorkTypes
                              value={selectedWorkOrderWorkTypes}
                              onChange={(value) => this.handlerInput('selectedWorkOrderWorkTypes', value)}
                            />
                          </div>
                        )
                        : <></>
                    }
                  </div>
                  <div className="p-10-0">
                    <div className="flex-grow-0">
                      <div className="field_block checkbox_group">
                        <label htmlFor="workDescriptionCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="workDescriptionCheckbox"
                            type="checkbox"
                            name="workDescriptionCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('description', event.target.checked)}
                            checked={fieldsToUpdate.has('description')}
                          />
                          <span>Work Description:</span>
                        </label>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('description')
                        ? (
                          <div md="8">
                            <EditorInput name="description" />
                          </div>
                        )
                        : <></>
                    }
                  </div>
                  <div className="p-10-0">
                    <div className="flex-grow-0">
                      <div className="field_block checkbox_group">
                        <label htmlFor="customToolsCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="customToolsCheckbox"
                            type="checkbox"
                            name="customToolsCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('customTools', event.target.checked)}
                            checked={fieldsToUpdate.has('customTools')}
                          />
                          Tools Required:
                        </label>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('customTools')
                        ? (
                          <div md="8">
                            <EditorInput name="customTools" />
                          </div>
                        )
                        : <></>
                    }
                  </div>
                  <div className="p-10-0">
                    <div className="flex-grow-0">
                      <div className="field_block checkbox_group">
                        <label htmlFor="confidentialInformationCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="confidentialInformationCheckbox"
                            type="checkbox"
                            name="confidentialInformationCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('confidential', event.target.checked)}
                            checked={fieldsToUpdate.has('confidential')}
                          />
                          <span>Confidential Information:</span>
                        </label>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('confidential')
                        ? (
                          <div md="8">
                            <EditorInput name="confidential" />
                          </div>
                        )
                        : <></>
                    }
                  </div>
                  <div className="p-10-0">
                    <div className="flex-grow-0 flex-box flex-align-center">
                      <div className="field_block checkbox_group">
                        <label htmlFor="woCompanyCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="woCompanyCheckbox"
                            type="checkbox"
                            name="woCompanyCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('woCompanyId', event.target.checked)}
                            checked={fieldsToUpdate.has('woCompanyId')}
                          />
                          Company:
                        </label>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('woCompanyId')
                        ? (
                          <div md="8">
                            <SelectWorkOrderCompany
                              name="woCompanyId"
                            />
                          </div>
                        )
                        : <></>
                    }
                  </div>
                  <div className="p-10-0">
                    <div className="flex-grow-0 flex-box flex-align-center">
                      <div className="field_block checkbox_group">
                        <label htmlFor="woProjectCheckbox" className="wo-check-btn check_btn dashboard-filter-check bulk-edit-check">
                          <input
                            id="woProjectCheckbox"
                            type="checkbox"
                            name="woProjectCheckbox"
                            className="input-field"
                            onChange={(event) => this.handlerUpdatingFields('projectId', event.target.checked)}
                            checked={fieldsToUpdate.has('projectId')}
                          />
                          <span>Project:</span>
                        </label>
                      </div>
                    </div>
                    {
                      fieldsToUpdate.has('projectId')
                        ? (
                            <SelectWorkProject name="projectId" />
                        )
                        : <></>
                    }
                  </div>
                  </div>
                    <div className="dashboard-modal-footer">
                      <button type="submit" className="dashboard-btn dashboard-btn--primary">
                        Update
                      </button>
                    </div>
                  </form>
                )
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  toggleModal,
  bulkEditWorkOrders,
  getWorkOrdersForBulk,
  getAccountBalanceByClient,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.bulkEditWorkOrders,
  activeTab: state.applicationState.activeTab,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  profile: state.profile,
  filters: state.workOrder?.filters,
  search: state.workOrder?.searchData,
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkEditWorkOrders);
